import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charCodeAt1yspne1d8erbm as charCodeAt,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  toString3o7ifthqydp6e as toString,
  _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx,
} from '../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { titlecase36e9fbud5gg4t as titlecase } from '../../../kotlin-kotlin-stdlib/kotlin/text/Char.mjs';
import {
  isLowerCase16nv9n55l9laa as isLowerCase,
  isWhitespace25occ8z1ed1s9 as isWhitespace,
} from '../../../kotlin-kotlin-stdlib/kotlin/text/charJs.mjs';
import { toString1pkumu07cwy4m as toString_0 } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { substring3saq8ornu0luv as substring } from '../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Regexxgw0gjiagf4z as Regex } from '../../../kotlin-kotlin-stdlib/kotlin/text/regex.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_casingSeparatorRegex() {
  _init_properties_casing_kt__ddte3x();
  return casingSeparatorRegex;
}
var casingSeparatorRegex;
function titleCase(_this__u8e3s4) {
  _init_properties_casing_kt__ddte3x();
  // Inline function 'com.lightningkite.caseAlter' call
  var tmp = get_casingSeparatorRegex();
  var tmp$ret$0 = tmp.xh(_this__u8e3s4, titleCase$lambda);
  return capitalize(tmp$ret$0);
}
function capitalize(_this__u8e3s4) {
  _init_properties_casing_kt__ddte3x();
  // Inline function 'kotlin.text.replaceFirstChar' call
  var tmp;
  // Inline function 'kotlin.text.isNotEmpty' call
  if (charSequenceLength(_this__u8e3s4) > 0) {
    var it = charCodeAt(_this__u8e3s4, 0);
    var tmp$ret$1 = isLowerCase(it) ? titlecase(it) : toString(it);
    tmp = toString_0(tmp$ret$1) + substring(_this__u8e3s4, 1);
  } else {
    tmp = _this__u8e3s4;
  }
  return tmp;
}
function titleCase$lambda(it) {
  _init_properties_casing_kt__ddte3x();
  var tmp;
  if (it.yh().j1() === 0) {
    tmp = it.f2();
  } else {
    // Inline function 'kotlin.text.filter' call
    var tmp0 = it.f2();
    // Inline function 'kotlin.text.filterTo' call
    var destination = StringBuilder().d1();
    var inductionVariable = 0;
    var last = charSequenceLength(tmp0);
    if (inductionVariable < last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var element = charSequenceGet(tmp0, index);
        if (!(element === _Char___init__impl__6a9atx(45) || element === _Char___init__impl__6a9atx(95) || isWhitespace(element))) {
          destination.xb(element);
        }
      }
       while (inductionVariable < last);
    var it_0 = destination.toString();
    tmp = ' ' + capitalize(it_0);
  }
  return tmp;
}
var properties_initialized_casing_kt_g7zmvl;
function _init_properties_casing_kt__ddte3x() {
  if (!properties_initialized_casing_kt_g7zmvl) {
    properties_initialized_casing_kt_g7zmvl = true;
    casingSeparatorRegex = Regex().qh('([-_\\s]+([A-Z]*[a-z0-9]+))|([-_\\s]*[A-Z]+)');
  }
}
//region block: exports
export {
  titleCase as titleCasej01kvzva6qlf,
};
//endregion

//# sourceMappingURL=casing.mjs.map
